import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Menus, subMenus } from '../../core/interface/header';
import { CalAngularService, ICvxClaimsPrincipal } from '@cvx/cal-angular';
import { DataService } from '../../core/service/data_service';
import { UserDetails } from '../../core/interface/user';
import { Facility, HeaderMenuNames } from '../../core/constants/header-menus';
import { SessionStorageService } from '../../core/service/session-storage';
import { NavigationStart, Router } from '@angular/router';
import { CommonService } from '../../core/service/common.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { filter } from 'rxjs';
import { Location } from '@angular/common';
import { header } from '../../core/constants/constants';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.less',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() validUser!: boolean;
  isUserLoggedIn!: boolean;
  currentUserProfile!: ICvxClaimsPrincipal;
  loggedUser!: UserDetails[];
  userFirstName: string | undefined = '';
  isVisible: boolean = false;
  menuLists: Menus[] = HeaderMenuNames;
  facilityName: string = '';
  fac_Id: string = '';
  disableNavigation: boolean = false;
  private subscription!: Subscription;
  currentUrl: string | null = null;
  header = header;

  constructor(
    private readonly authService: CalAngularService,
    private readonly dataService: DataService,
    private readonly session: SessionStorageService,
    private readonly route: Router,
    private readonly commonService: CommonService,
    private readonly location: Location
  ) {}

  ngOnInit(): void {
    this.currentUrl = this.route.url;
    this.getLoggedInUserDetails();
    if (this.session.getItem('userAccess')) {
      this.fac_Id = this.session.getItem('userAccess')['faC_ID'];
      this.facilityName = Facility.find((obj) => obj.fac_Id === this.fac_Id)
        ?.name as string;
    }

    this.subscription = this.commonService.disableNavigation$.subscribe(
      (disabled) => {
        this.disableNavigation = disabled;
      }
    );

    this.route.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.currentUrl = event.url;
      });
  }

  previousPage(): void {
    this.location.back();
  }

  // get logged in user details name, mail, id
  getLoggedInUserDetails() {
    this.dataService.loggedUserDetails.subscribe((res: UserDetails[]) => {
      this.loggedUser = [...new Set(res)];
      this.userFirstName = this.loggedUser[0]?.fullName;
    });
  }

  openAction(menuname: string, subMenu: subMenus) {
    if (menuname.toLowerCase() == 'facility') {
      if (this.fac_Id == 'HA') {
        alert(
          'Personnel with a base facility of Hawaii are not authorized to switch facilities.'
        );
        return;
      }

      if (this.fac_Id != 'HA' && subMenu.fac_Id == 'HA') {
        alert(
          'Non Hawaii Personnel are no longer authorized to switch to the Hawaii Facility'
        );
        return;
      }
      this.fac_Id = subMenu.fac_Id ?? '';
      this.facilityName = subMenu.name;
      this.dataService.updateFacility(subMenu.fac_Id ?? '');
    }
  }

  showModal(): void {
    this.isVisible = !this.isVisible;
  }
  // to logout the user and navigate to Microsoft login page.
  logout() {
    this.authService.userInitiatedSignOut().subscribe(() => {});
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
